export class Helper {
    static numberFormat(value:number) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
}
